import {styled} from "@mui/material";

type TMainProps = {
    isLogin: boolean
}
export const MainBody = styled('main', {
    shouldForwardProp: (propName) => propName !== 'isLogin'
})<TMainProps>(({isLogin, theme}) => ({
        background: isLogin ? '#EFEDEE' : '#fff',
        height: '100%',
        minHeight: '100vh',
        transition: '.3s',
        width: isLogin ? '100%' : 'calc(100% - 20rem)',
        marginLeft: isLogin ? 0 : '20rem',

        '&.login': {
            maxWidth: '100vw',
            width: '100vw',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10rem 0',
                [theme.breakpoints.down('br768')]: {
                padding: 0
                }
        },

        [theme.breakpoints.down('md')]: {
            width: '100%',
            marginLeft: 0,
            paddingTop: '5rem'
        }
    })
)
